import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteAccount } from "../../store/thunks/profileThunk";
import SweetAlert from "react-bootstrap-sweetalert";

import Header from "../../components/common/Header";
import { useAuthContext } from "../../features/authentication";
import { useNavigate } from "react-router-dom";

const DeleteAccountPage = () => {
    const navigate = useNavigate();
    const { logOut } = useAuthContext();
    const dispatch = useDispatch();
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const handleDelete = async () => {
        setIsDeleting(true);
        setError("");
        setShowPopup(false);
        try {
            const result = await dispatch(deleteAccount()).unwrap();
            if (result) {
                await logOut();
                navigate("/sign-in");
            }
            setSuccess(true);
        } catch (err) {
            setError("Failed to delete account. Please try again.");
        } finally {
            setIsDeleting(false);
            setShowPopup(false);
        }
    };

    if (success) {
        return <div>Your account has been deleted successfully.</div>;
    }

    return (
        <>
            <Header />
            <div className="container d-flex flex-column align-items-center justify-content-center" style={{ minHeight: "60vh" }}>
                <h2 className="text-center">Delete Account</h2>

                {error && <div className="alert alert-danger">{error}</div>}
                {success ? (<div className="alert alert-success">Your account has been deleted successfully.</div>) : (
                    <>

                        <p className="text-center">
                            Are you sure you want to delete your account? This action cannot be undone and all your data will be lost.
                        </p>
                        {error && <div className="text-danger mb-3 text-center">{error}</div>}
                        {isDeleting ? (
                            <div className="d-flex justify-content-center align-items-center gap-3 mt-2">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only"></span>
                                </div>
                                <p>Deleting your account, please wait...</p>
                            </div>
                        ) : (
                            <button
                                onClick={() => setShowPopup(true)}
                                disabled={isDeleting}
                                className="btn btn-danger mt-2"
                            >
                                Delete My Account
                            </button>
                        )}

                    </>
                )}
            </div>
            {showPopup && (
                <SweetAlert
                    danger
                    title={"Are you sure you want to delete your account? You won't be able to recover it and all your data will be lost."}
                    confirmBtnText={"Yes, delete it!"}
                    confirmBtnBsStyle="danger"
                    showCancel
                    focusCancelBtn
                    onConfirm={handleDelete}
                    onCancel={() => setShowPopup(false)}
                    confirmBtnDisabled={isDeleting}
                    cancelBtnDisabled={isDeleting}
                />
            )}
        </>
    );
};

export default DeleteAccountPage;
